import { route, navigate, type Tab } from '@/state/nav';
import { Icon, type IconName } from '@/components/Icon';

const TABS: { tab: Tab; label: string; icon: IconName; path: string }[] = [
  { tab: 'chat', label: 'Chat', icon: 'chat', path: '/' },
  { tab: 'now', label: 'Now', icon: 'paw', path: '/now' },
  { tab: 'calendar', label: 'Calendar', icon: 'cal', path: '/calendar' },
  { tab: 'more', label: 'More', icon: 'grid', path: '/more' },
];

export function TabBar({ overdueDot }: { overdueDot: boolean }) {
  const active = route.value.tab;
  return (
    <nav class="tabbar" aria-label="Primary">
      {TABS.map(({ tab, label, icon, path }) => (
        <button
          key={tab}
          class={`tab ${active === tab ? 'is-active' : ''}`}
          aria-current={active === tab ? 'page' : undefined}
          onClick={() => navigate(path)}
        >
          {tab === 'now' && overdueDot && <span class="tab__indicator" aria-label="overdue feedings" />}
          <Icon name={icon} />
          {label}
        </button>
      ))}
    </nav>
  );
}
